import type { TOC } from '@ember/component/template-only'
import { hash } from '@ember/helper'
import { on } from '@ember/modifier'
import { LinkTo } from '@ember/routing'
import { t } from 'ember-intl'
import { and, not } from 'ember-truth-helpers'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

interface Signature {
  Element: HTMLDivElement
  Args: {
    collectionId: Nullable<string>
    showShareLink: boolean
    isFavourite?: boolean
    deleteCollectionAction: () => void
  }
}

export const CollectionCardHeader: TOC<Signature> = <template>
  <div class="text-oceany-blue-350 flex justify-between" ...attributes>
    {{#if (and @collectionId @showShareLink)}}
      <LinkTo
        aria-label={{t "bookLibrary.collection.share.label"}}
        @route="subscription-type.book-library.shares.new"
        @query={{hash collectionId=@collectionId}}
      >
        <span class="hover:underline">
          <PhosphorIcon @icon="phosphor-calendar-check-fill" class="mr-2" /><span
            class="text-dusty-black-250 uppercase"
          >{{t "bookLibrary.collection.share.label"}}</span>
        </span>
      </LinkTo>
    {{else}}
      <span></span>
    {{/if}}
    {{#if (and (not @isFavourite) @deleteCollectionAction)}}
      <button
        type="button"
        aria-label="{{t 'bookLibrary.collection.delete.label'}}"
        class="text-dusty-black-250 hover:text-watermelony-red-350 focus:text-watermelony-red-350"
        {{on "click" @deleteCollectionAction}}
      >
        <PhosphorIcon @icon="phosphor-trash-fill" />
      </button>
    {{/if}}
  </div>
</template>
